import { render, staticRenderFns } from "./WidgetDaysCA.vue?vue&type=template&id=685fbfd1"
import script from "./WidgetDaysCA.vue?vue&type=script&lang=js"
export * from "./WidgetDaysCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports